import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-16">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#F0FDF4] rounded-2xl p-8 border border-[#DCF8C6]" data-id="element-17">
            <h3 className="text-2xl font-bold text-[#0B6B3A] mb-6 flex items-center gap-2" data-id="element-18">
              <Check className="w-6 h-6" data-id="element-19" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {['Vendes por DM (Instagram) o WhatsApp', 'Te piden precio y desaparecen', 'Te cuesta cobrar sin sentir culpa', 'Quieres un sistema corto y ejecutable HOY'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <Check className="w-5 h-5 text-[#0B6B3A] mt-0.5 flex-shrink-0" data-id="element-22" />
                  <span className="text-gray-800" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-24">
            <h3 className="text-2xl font-bold text-gray-500 mb-6 flex items-center gap-2" data-id="element-25">
              <X className="w-6 h-6" data-id="element-26" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-27">
              {['No vendes por chat (solo ecommerce automático)', 'Tu venta es corporativa con ciclos de meses', "Buscas 'motivación' (esto es pura ejecución)", 'Esperas una fórmula mágica sin poner de tu parte'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-28">
                  <X className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-29" />
                  <span className="text-gray-600" data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}